import React from "react";
import { Icon } from "@iconify/react";

const Revolutionize = ({ txt }) => {
  return (
    <div className=" relative  md-m:hidden revolution-div px-[20px] py-[30px] flex justify-center">
      <div className="flex items-center w-fit  gap-[12px]  max-md:w-[90%] ">
        <Icon
          color="#FFFFFF"
          icon="mdi:sparkles"
          width={44}
          height={44}
          className="md-m:w-[32px] md-m:h-[32px]"
        />
        <h4 className="text-[#E0E0E0]  max-md:!py-[0px] text-center font-sora max-xxxl:text-[32px] md-m:!text-[28px]]">
          {txt}
        </h4>
        <Icon
          color="#FFFFFF"
          icon="mdi:sparkles"
          width={44}
          height={44}
          className="md-m:w-[32px] md-m:h-[32px]"
        />
      </div>
    </div>
  );
};

export default Revolutionize;
